/**
 * DEPRECATED
 */


import $util from './util';


/** Delete all overlays associated with this Vue instance */

function destroyOverlays() {
    const all = this.$overlay.all;
    this.$overlay.all = null;
    for (let key in all) {
        if (all[key].$parent === this) {
            all[key].$destroy();
            document.body.removeChild(all[key].$el);
        }
    }
}


/** Support modals, popovers, etc as singleton children of body */

export default function(component, props, events) {

    // Default behavior: return parent overlay component, or `null` if none
    if (component === undefined) {
        let c = this;
        while (c) {
            if (c._ovlChild || c.isProxy_) {
                return c;
            }
            c = c.$parent;
        }
        return null;
    }

    // Create overlay from this component
    if (component.name == null) {
        console.error('$overlay: component.name undefined');
        return null;
    }
    if (this.$overlay.all == null) {
        this.$overlay.all = {};
        this.$options.destroyed = (this.$options.destroyed || []).slice();
        this.$options.destroyed.push(destroyOverlays);
    }
    let vm = this.$overlay.all[component.name];
    if (!vm) {
        const Ctor = Vue.extend(component);
        vm = new Ctor({
            parent: this,
            propsData: props
        });
        vm._ovlChild = new Set();
        vm.$mount();
        this.$overlay.all[component.name] = vm;
    } else if (props) {
        //TODO: This is a workaround - long term solution is https://prod.ibkr-web.com/ibjira/browse/WEBPLTFRM-149
        const error = console.error;
        console.error = () => {};
        vm.$parent = this;
        for (let prop in vm.$options.props) {
            if (props[prop] !== void 0) {
                vm[prop] = props[prop];
            } else {
                vm[prop] = vm.$options.props[prop].default;
            }
        }
        console.error = error;
    }
    vm._events = {};
    if (events) {
        for (let event in events) {
            vm.$on(event, events[event]);
        }
    }
    if (vm.$el !== document.body.lastChild) {
        document.body.appendChild(vm.$el);
    }
    return vm;
}
